import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'title'
	| 'sidebarTitle'
	| 'description'
	| 'addChatsCta'
	| 'dismissLabel'
	| 'dismissButtonLabel';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		title: {
			id: 'rovo-spaces.past-conversations-banner.title',
			defaultMessage: 'Bring past conversations into this space',
			description:
				'Title of a recommendation banner shown on the Rovo Space landing page that prompts the user to add chats from their history into the current space. Used on the wide (inline) variant of the banner.',
		},
		sidebarTitle: {
			id: 'rovo-spaces.past-conversations-banner.sidebarTitle',
			defaultMessage: 'Bring conversations into this space',
			description:
				'Title of the past conversations recommendation banner when rendered in the narrow Rovo sidebar (stacked variant). Shorter than the wide-variant title because the narrow column does not fit "past".',
		},
		description: {
			id: 'rovo-spaces.past-conversations-banner.description',
			defaultMessage:
				'{count, plural, one {We found # relevant chat from your history. Add it to this space for better context and continuity.} other {We found # relevant chats from your history. Add them to this space for better context and continuity.}}',
			description:
				'Subtitle of the past conversations recommendation banner. {count} is the number of recommended chats found.',
		},
		addChatsCta: {
			id: 'rovo-spaces.past-conversations-banner.addChatsCta',
			defaultMessage: 'Add chats',
			description:
				'Primary CTA on the past conversations recommendation banner. Opens a picker for the user to add chats to the space.',
		},
		dismissLabel: {
			id: 'rovo-spaces.past-conversations-banner.dismissLabel',
			defaultMessage: 'Dismiss past conversations recommendation',
			description:
				'Accessible label for the dismiss (×) icon button on the past conversations recommendation banner. Used on the wide (inline) variant where the affordance is an icon-only button.',
		},
		dismissButtonLabel: {
			id: 'rovo-spaces.past-conversations-banner.dismissButtonLabel',
			defaultMessage: 'Dismiss',
			description:
				'Visible text on the full-width dismiss button shown on the narrow Rovo sidebar (stacked variant) of the past conversations recommendation banner. Doubles as the accessible name.',
		},
	});

export default messages;
